export const authRoles = {

    // user routes
    myProfile: [1, 2, 3, 4, 5, 6],
    // registerUser: [1, 2],
    userManagement: [1],
    // registerUserOrgContributor: [3],

    //organization routes
    orgnization:[1,2,3],
    addNewOrganization: [2, 3],
    orgManagement: [1],

    //usermanagement
    orgAdminUserManagement: [2,3],

    //portal routes
    viewerPortal: [5],
    orgAdminPortal: [2],
    orgContributorPortal: [3],
    individualContributorPortal: [4],
    AdminPortal: [1],

    //configuration routes
    configurations: [1],
    targetConfiguration: [1],
    orgConfiguration: [1],
    expenseConfiguration: [1],
    
    //expense dashboards
    expenseDashboards: [1, 2, 3, 4, 5, 6],
    viewerExpenseDashboard: [6],
    individualContributorExpenseDashboard: [4],
    orgContributorExpenseDashboard: [3],
    orgAdminExpenseDashboard: [2],
    AdminExpenseDashboard: [1],
    AddExpense: [4,3,2,1],
    reviewExpense:[2,1],
    
    
    




    // dashboard: [2], // Only Super Admin has access
    // viewExpenseDashboard : [1],
    // aptituteTest: [2, 'ADMIN'],
    // aptituteTestCreate: [2, 'ADMIN'],
    // aptituteTestView: [2, 'ADMIN'],
    // TestPaperCreate: [2, 'ADMIN'],
    // appicationView: [2, 'ADMIN'],
    // orgAdmin:[2,'ADMIN'],
    // orgContributor:[2,'ADMIN'],
}

// Check out app/views/dashboard/DashboardRoutes.js
// Only SA & Admin has dashboard access

// const dashboardRoutes = [
//   {
//     path: "/dashboard/analytics",
//     component: Analytics,
//     auth: authRoles.admin <===============
//   }
// ];

// Check navigaitons.js

// {
//   name: "Dashboard",
//   path: "/dashboard/analytics",
//   icon: "dashboard",
//   auth: authRoles.admin <=================
// }
